import { createSelector } from 'reselect';

const storeInternships = (store, props) => store.internshipData.internships;
const storeInternshipDataIds = (store, props) => store.internshipData.dataIds;

export const getInternships = createSelector(
  storeInternships,
  storeInternshipDataIds,
  (internships, ids) => {
    return (
      internships &&
      ids &&
      ids.length > 0 &&
      ids.map(id => {
        let internshipObj = internships[id];
        internshipObj['internship_id'] = id;
        return internshipObj;
      })
    );
  }
);



// WEBPACK FOOTER //
// ./src/selectors/internships.js